import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { useQuery } from '@apollo/react-hooks';
import { DOCUMENT_LIST_QUERY } from '../services/document-management.service';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { Panel } from 'primereact/panel';
import DocumentsList from '../components/DocumentsList';

const Documents = () => {
  const [documents, setDocuments] = useState([]);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { loading, error, data } = useQuery(DOCUMENT_LIST_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'no-cache',
  });

  const { account } = data;

  useEffect(() => {
    if (account) {
      setDocuments(account.documents);
    }
    // eslint-disable-next-line
  }, [account]);

  if (error) {
    growlErrors(growl, error);
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel header="Legal Documents">
            <DocumentsList loading={loading} documents={documents} />
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default Documents;
